export default "__VITE_ASSET__mQZRlgOg__"